<template>
  <div class="box m-t-20">
    <h4 class="title is-4">
      {{ $t('groupDeal.createDealTitle') }}
    </h4>
    {{ $t('groupDeal.createDealDescription') }}
    <div class="m-t-10">
      <steps conditions :steps="data.prices" />
    </div>
    <div class="columns m-t-10 is-vcentered">
      <div class="column is-narrow">
        <b-button type="is-dark-green" @click.stop="create">
          {{ $t('groupDeal.createDeal') }}
        </b-button>
      </div>
      <div class="column has-text-right-tablet">
        {{ $t('groupDeal.dateEnd') }}
        <nobr>
          {{ $moment(data.dateEnd).format('L LT') }}
        </nobr>
      </div>
    </div>
  </div>
</template>

<script>
import Steps from '~/marketplace-front-core/components/shared/Steps'

export default {
  components: { Steps },
  props: {
    data: {
      type: Object,
      default () {
        return null
      }
    },
    offerProduct: {
      type: Number,
      required: true
    }
  },
  methods: {
    create () {
      this.$api.groupDeal.create(this.offerProduct, this.data.id)
        .then((res) => {
          this.$router.push(this.localePath({ name: 'groupDeal', params: { identify: res.identifier } }))
        })
    }
  }
}
</script>
